<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtros
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <b-form-group>
            <h5>Data Início da Validade</h5>
            <flat-pickr
              v-model="dataInicioValidadeFilter"
              class="form-control"
              :config="{ dateFormat: 'd/m/Y'}"
            />
          </b-form-group>

        </b-col>

        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <b-form-group>
            <h5>Data Término da Validade</h5>
            <flat-pickr
              v-model="dataTerminoValidadeFilter"
              class="form-control"
              :config="{ dateFormat: 'd/m/Y'}"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BFormGroup, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    flatPickr,
    BFormGroup,
  },
  model: {
    prop: 'filters',
    event: 'updateFilters',
  },
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    filters: {
      handler() {
        this.$emit('updateFilters', this.filters)
      },
      deep: true,
    },
  },
  computed: {
    dataTerminoValidadeFilter: {
      get() {
        return this.filters.dataTerminoValidadeFilter
      },
      set(val) {
        this.filters.dataTerminoValidadeFilter = val
      },
    },
    dataInicioValidadeFilter: {
      get() {
        return this.filters.dataInicioValidadeFilter
      },
      set(val) {
        this.filters.dataInicioValidadeFilter = val
      },
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
